import { Navigate, Route, Routes } from "react-router-dom";
import { guestRoutes, standardRoutes } from "../../constants/routes";
import { Loader } from "../common/Loader";
import { useAuth } from "../context/AuthContext";
import { DashboardLayout } from "./DashboardLayout";

export const MainContainer = () => {
  const { loggedIn } = useAuth();

  // const loggedIn = true;
  if (loggedIn === true) {
    // ROUTES
    return (
      <DashboardLayout>
        <Routes>
          {standardRoutes.map(({ path, component }, i) => (
            <Route path={path} element={component} key={i} />
          ))}
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </DashboardLayout>
    );
  } else if (loggedIn === false) {
    return (
      <Routes>
        {guestRoutes.map(({ path, component }, i) => (
          <Route path={path} element={component} key={i} />
        ))}
        <Route path="*" element={<Navigate replace to="/auth/login" />} />
      </Routes>
    );
  } else {
    // LOADER
    if (loggedIn === null) return <Loader />;
  }
  return null;
};
